import { type BuyAndReplaceResult } from '../../store/user/user'
import { seatsBought } from './buyResult'

export interface RoleChangeBuyVerdict {
  applied: boolean
  bought: boolean
  message?: string
}

const UNCONFIRMED = 'We could not confirm the purchase. Reopen this window to see the current seats and roles.'
const PAYMENT_METHOD_MISSING = 'A payment method is needed before you can buy a seat. You can add one on the Plan page.'
const PURCHASE_FAILED = 'The purchase did not go through, so the role was not changed.'
const BOUGHT_NOT_APPLIED = 'The seat was purchased, but the role could not be changed. The seat stays on your plan, and you can use it from the Team list.'

export const readRoleChangeBuyResult = (result: BuyAndReplaceResult | undefined): RoleChangeBuyVerdict => {
  if (!result) {
    return { applied: false, bought: false, message: UNCONFIRMED }
  }

  const bought = seatsBought(result.purchased)

  if (result.rolesApplied) {
    return { applied: true, bought }
  }

  if (result.checkoutRequired) {
    return { applied: false, bought, message: PAYMENT_METHOD_MISSING }
  }

  switch (result.reason) {
    case 'paymentRequired':
      return { applied: false, bought, message: PAYMENT_METHOD_MISSING }
    case 'purchaseFailed':
      return { applied: false, bought, message: PURCHASE_FAILED }
    case 'noSeatAvailable':
    case 'roleChangeFailed':
      return { applied: false, bought, message: BOUGHT_NOT_APPLIED }
    case 'purchaseUnconfirmed':
    default:
      return { applied: false, bought, message: UNCONFIRMED }
  }
}
